import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { StsRootConfigObject } from '../models/sts-account-config.model';
import { StsTenant } from '../models/sts-tenant.model';
import { StsConfigService } from './sts-config.service';
import { StsHttpService } from './sts-http.service';
import { StsCaptchaType } from 'app/models/sts-captcha-type.model';

@Injectable()
export class StsTenantService {
  private tenantSource: Observable<StsTenant> = null;
  private accountConfig: Observable<StsRootConfigObject> = null;

  constructor(private http: StsHttpService,
              private config: StsConfigService) {
    this.tenantSource = this.http.get<StsTenant>('/api/tenants', null,
      res => {
        let clientSpecific = res.clientSpecific || 'HOOPP';
        // var clientSpecific = 'IMRF'; // use this to test specific client specific Sitefinity

        let cs = `client-${ clientSpecific.toUpperCase() }`;
        if (!document.body.className) {
          document.body.className += cs;
        }

        if (!res.captchaType) {
          res.captchaType = StsCaptchaType.text;
        }

        return res;
      })
      .pipe(
        share<StsTenant>()
      );
    this.accountConfig = this.http.get<StsRootConfigObject>('/Account/GetClientSettings', null,
      res => {
        if (!res) {
          let n = Math.floor(Math.random() * 11) + 1  ;
          let bg = this.config.normalizePath(`app/assets/images/backgrounds/${n}.jpg`);
          res = new StsRootConfigObject();
          res.loginBackgroundImage = bg;
          res.logo = '';
        }
        return res;
      })
      .pipe(
        share<StsRootConfigObject>()
      );
    this.tenantSource.subscribe();
    this.accountConfig.subscribe();
  }

  public getTenantSource(): Observable<StsTenant> {
    return this.tenantSource;
  }

  public getConfigSource(): Observable<StsRootConfigObject> {
    return this.accountConfig;
  }
}
